import React from 'react';
import { AccordanceType } from '../../../../../models/AccordanceType';
import AccordanceInfoItem from './AccordanceInfoItem';
import Comments from '../../../../Util/Comments/Comments';
import AccordanceFiles from '../AccordanceFiles/AccordanceFiles';
import { newAccordanceComment, deleteAccordanceComment } from '../../../../../api/accordanceApi';
import { isDraftOrPending } from '../NewAccordanceForm/NewAccordanceFormUtil';
import { useTranslation } from 'react-i18next';
import { AccordanceState } from '../../../../../models/AccordanceState';

type Props = {
  accordance: any;
};

const SupervisionActionAndComments = ({ accordance }: Props) => {
  const { t } = useTranslation();
  const { id, accordanceFiles, accordanceComments, accordanceState, rejectionDetail } = accordance;

  return (
    <>
      {accordanceFiles && accordanceFiles.length > 0 && <AccordanceFiles files={accordanceFiles} />}
      <Comments
        comments={accordanceComments || []}
        submitComment={comment => newAccordanceComment(id, comment)}
        submitDeleteComment={commentId => deleteAccordanceComment(id, commentId)}
        canDeleteComments={isDraftOrPending(accordanceState)}
        accordanceState={accordanceState}
        rejectionDetail={rejectionDetail}
        readonly={accordanceState === AccordanceState.REJECT}
      />
    </>
  );
};

export default SupervisionActionAndComments;
